import React from "react";
import { useTranslation } from "react-i18next";
import meet from "../../assets/images/meeting2.jpg";

export default function EnterpriseComponent() {
    const { t } = useTranslation();

    return (
        <div
            className="tab-content-details-wrapper"
            style={{
                backgroundImage: `url(${meet})`,
                backgroundSize: "cover",
                backgroundPosition: "center bottom",
            }}
        >
            <div className="tab-label">
                <div>
                    {/* {t("For Post Secondary")} */}A Virtual Learning
                    Management System For Higher Education
                </div>
            </div>
        </div>
    );
}
